import ProductPriceFormat from '../../products/product-price/product-price-format';
import DiscountBadge from '../../../ui/discount-badge/discount-badge';
import { IYouMayAlsoLikeItem } from '../../shopping-cart/cart-bridger-pay/interfaces';

interface IYouMayAlsoLikeItemPrices {
    item: IYouMayAlsoLikeItem;
}

const YouMayAlsoLikeItemPrices = ({ item }: IYouMayAlsoLikeItemPrices) => {

    const couponPrice = item?.couponPrice ?? 0;
    const couponCode = item?.couponCode || '';
    const discount = item?.discount ?? 0;

    const withCouponEnabled = !!item && item?.couponCampaignID > 0;
    const isWithCoupon = withCouponEnabled && couponPrice > 0;
    const isSamePrice = item?.skU_MSRP === item?.skuPrice;

    return (
        <>
            {
                item &&
                <div className="flex flex-col col-start-2 col-end-2 md:col-auto">
                    {/* prices row #1: different prices / with coupon */}
                    {
                        (couponPrice > 0 || !isSamePrice) &&
                        <div className="flex items-center">

                            {/* MSRP price */}
                            <div className="text-sm text-gray-500 mr-2">
                                <s aria-hidden="true"><ProductPriceFormat price={item.skU_MSRP}
                                                                          accessible={false}/></s>
                                <span className="sr-only">Full Price ${item.skU_MSRP}</span>
                            </div>

                            {/* on sale: sku price if 'with coupon' price exists */}
                            {
                                (couponPrice > 0 && !isSamePrice) &&
                                <div className="text-sm text-gray-500">
                                    <ProductPriceFormat price={item.skuPrice} />
                                </div>
                            }
                        </div>
                    }

                    {/* prices row #1: same price */}
                    {
                        (isSamePrice && couponPrice <= 0) &&
                        <div className="flex items-center text-base text-gray-500">Now</div>
                    }

                    {/* prices row #2 */}
                    <div className="flex items-center">

                        {/* main price: if 'with coupon' exists -> 'with coupon' price, otherwise sku price */}
                        <div className="text-xl font-bold text-gray-700">
                            {
                                isWithCoupon &&
                                <span>
                            <ProductPriceFormat price={couponPrice}/>&nbsp;

                                    <span className="sr-only">
                                With Coupon: <span>{couponCode}</span>
                            </span>
                        </span>
                            }

                            {!isWithCoupon && <ProductPriceFormat price={item.skuPrice}/>}

                        </div>

                        {/* discount red tag */}
                        {
                            discount > 0 &&
                            <DiscountBadge discount={discount}/>
                        }
                    </div>

                    {/* prices row #3 */}
                    {
                        couponCode &&
                        <div className="flex items-center">
                            <div className="text-sm text-gray-700 font-bold" aria-hidden={true}>With Coupon: <span>{couponCode}</span></div>
                        </div>
                    }

                    {/*{
                        addedCartItem.saleEndDate &&
                        <div className="mt-4">
                            <ProductClock saleEndDate={new Date(addedCartItem.saleEndDate)}/>
                        </div>
                    }*/}
                </div>
            }
        </>
    )
};

export default YouMayAlsoLikeItemPrices;